import { Logger } from '@empathy/logger';
import { Component, Vue } from 'vue-property-decorator';
import { BUS } from '../../../bus';
import { logger } from '../../../logger';
import { Dictionary } from '../../../utils';
import { Wire, WIRING } from '../../../wiring';

@Component
export class CoreWiringMixin extends Vue {

  private logger: Logger;
  private wiringLog: Dictionary<string[]>;

  created() {
    this.logger = logger.child('[CORE]', '[WIRING]');
    this.wiringLog = {};
    Object.entries<Wire[]>(WIRING).forEach(wiring => {
      if (this.isEventCorrect(wiring)) {
        this.applyWires(wiring);
      }
    });
    this.logger.info(this.wiringLog);
  }

  isEventCorrect([eventName, wires]: [string, Wire[]]): boolean {
    if (!eventName || eventName === 'undefined') {
      this.logger.error('undefined event', '[EVENT]', eventName, '[WIRES]', this.getWireInfo(wires));
      return false;
    } else {
      this.wiringLog[eventName] = this.getWireInfo(wires);
      return true;
    }
  }

  getWireInfo(wires: Wire[]): string[] {
    return wires.map(wire => wire ? (wire.name || wire.toString()) : 'undefined');
  }

  applyWires([eventName, wires]: [string, Wire[]]) {
    const wireParams = { store: this.$store, emit: this.$x.emit };
    wires.forEach((wire: Wire) => {
      if (wire) {
        wire(this.$x.on(eventName), wireParams);
      } else {
        this.logger.error('undefined wire', '[EVENT]', eventName, '[WIRE]', 'undefined');
      }
    });
  }
}
